import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build-time version stamp so users can quickly tell which release they have
// loaded. Injected via CRA env or falls back to a stable string.
window.__APP_BUILD_ID =
  process.env.REACT_APP_BUILD_ID ||
  (process.env.NODE_ENV === "production" ? "prod-2026-07-05" : "dev");

// Defensive: unregister any service worker AND clear caches from previous
// sessions. Some browsers keep SWs alive across incognito sessions or
// installs, and a stale SW can silently intercept /api/* fetches, producing
// "Error de red" / axios "no response" symptoms that survive hard-refreshes.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister().catch(() => {}));
  }).catch(() => {});
}
if (typeof window !== "undefined" && "caches" in window) {
  caches.keys().then((keys) => keys.forEach((k) => caches.delete(k).catch(() => {}))).catch(() => {});
}

// Redirect www → apex host to avoid the Cloudflare 308 that breaks POST /login
// (browser aborts credentialed POSTs on a permanent redirect → surfaces as
// "Error de red" / axios shows the default "Contraseña incorrecta"). We stop
// the SPA from mounting until the navigation happens.
if (typeof window !== "undefined" && window.location.hostname.startsWith("www.")) {
  const target =
    window.location.protocol +
    "//" +
    window.location.hostname.replace(/^www\./, "") +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(target);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
